import { FilterOutlined } from '@ant-design/icons'
import { Switch } from 'antd'
import { FilterListGlobalBean, ListResponseFilterListGlobalBean } from 'common/api/api'
import { getFilterListTypeName } from 'common/api/dictionaries.tsx'
import { find } from 'common/api/entities.tsx'
import { filterListGlobalApi } from 'common/api/entitiesApi'
import { ListCard } from 'common/components/ListCard'
import { SearchInput } from 'common/components/SearchInput'
import { ListFilters, useAppContext } from 'common/context/AppContext'
import { CommonRoutes } from 'common/context/commonRoutes'
import { COLUMN_ID_WIDTH, COLUMN_NAME_WIDTH } from 'common/util/constants'
import { initListFilters, useListFilters } from 'common/util/useListFilters'
import { apiCall } from 'common/util/Util'
import dayjs from 'dayjs'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ListActionButton } from 'common/components/ListActionButton.tsx'

const FilterListGlobalList = ({ admin, agency }) => {
  const appContext = useAppContext()
  const [loading, setLoading] = useState(false)
  const navigateTo = useNavigate()

  const initialFilters = {} as ListFilters
  const [filters, setFilters] = useState<ListFilters>(initListFilters(initialFilters))
  const { setFilter } = useListFilters(setFilters)

  const [listData, setListData] = useState<ListResponseFilterListGlobalBean>()

  const loadData = () => {
    apiCall(
      setLoading,
      appContext,
      () =>
        filterListGlobalApi.filterListGlobalPage(
          filters.sort?.name,
          filters.sort?.direction,
          filters.name,
          filters.filterListId,
          filters.agencyId,
          filters.advertiserId,
          filters.active,
          { query: { page: filters.page, size: filters.pageSize } },
        ),
      (response) => setListData(response),
    )
  }

  const toggleActive = (id: number) => {
    apiCall(
      setLoading,
      appContext,
      () => filterListGlobalApi.changeFilterListGlobalStatus(id),
      () => {
        const row = find(listData, id) as any
        row.active = !row.active
        setListData({ ...listData } as any)
      },
    )
  }

  return (
    <ListCard
      loading={loading}
      title="Global Filters"
      createName="Global Rule"
      createRoute={CommonRoutes.FILTER_LIST_GLOBAL_CREATE}
      listRouteKey={CommonRoutes.FILTER_LIST_GLOBAL}
      filters={filters}
      setFilters={setFilters}
      initialFilters={initialFilters}
      listData={listData}
      loadData={loadData}
      columns={[
        {
          title: 'ID',
          dataIndex: 'id',
          width: COLUMN_ID_WIDTH,
          fixed: 'left',
        },
        {
          title: 'Filter List Name',
          dataIndex: 'filterListName',
          sorter: true,
          render: (text, record: FilterListGlobalBean) => (
            <Link style={{ color: '#5888CF' }} to={`${CommonRoutes.FILTER_LIST_GLOBAL}/${record.id}/edit`}>
              {text}
            </Link>
          ),
          className: 'list-table-name',
          ellipsis: true,
          width: COLUMN_NAME_WIDTH,
          fixed: 'left',
        },
        {
          title: 'Type',
          dataIndex: 'filterListType',
          sorter: false,
          width: 180,
          render: (value) => getFilterListTypeName(value),
        },
        {
          title: 'Mode',
          dataIndex: 'mode',
          sorter: true,
          width: 120,
        },
        {
          title: 'Target',
          sorter: false,
          width: 160,
          render: (_, record: any) => {
            if (record.advertiserId) return `Advertiser: ${record.advertiserId}`
            if (record.agencyId) return `Agency: ${record.agencyId}`
            return 'Global'
          },
        },
        {
          title: 'Last Modified',
          dataIndex: 'modified',
          sorter: true,
          width: 150,
          render: (date) => date && dayjs(date).format('DD MMM YYYY'),
        },
        {
          title: 'Active',
          dataIndex: 'active',
          sorter: true,
          width: 80,
          render: (_val, record: any) => (
            <Switch size="small" checked={record.active} onChange={() => toggleActive(record.id)} />
          ),
        },
        {
          title: 'Actions',
          render: (_, record: FilterListGlobalBean) => (
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
              <ListActionButton
                onClick={() =>
                  navigateTo(`${CommonRoutes.FILTER_LIST}/${record.filterListId}/edit`, {
                    state: { returnTo: CommonRoutes.FILTER_LIST_GLOBAL },
                  })
                }
                aria-label="Open Filter List"
                tooltip='Open Filter List'
              >
                <FilterOutlined />
              </ListActionButton>
            </div>
          ),
          width: 100,
        },
      ]}
    >
      <SearchInput value={filters.name} onChange={(value) => setFilter('name', value)} />
    </ListCard>
  )
}

export default FilterListGlobalList
